const HOONE = 'hoone'

/**
 * Order EHR ehitised so actual buildings ("hoone") precede auxiliary structures
 * ("rajatis": telecom networks, water/sewer pipes, etc.). KASI (land) transactions
 * attach a dwelling plus several rajatis; the list arrives in `ehrbuilding.id` order,
 * so a low-id rajatis would otherwise become the default selection in the Ehitis tab.
 *
 * Stable (Array.prototype.sort is stable, ES2019+): same-category order is preserved,
 * and with no hoone present the array is returned unchanged so the first item still wins.
 *
 * @param {Array<{ehitise_liik?: string}>} buildings
 * @returns {Array} new array, hoone-first
 */
export function orderBuildingsHooneFirst(buildings) {
  if (!Array.isArray(buildings)) {
    return []
  }

  return [...buildings].sort(
    (a, b) => (b?.ehitise_liik === HOONE) - (a?.ehitise_liik === HOONE),
  )
}
